@if (!isAddUser) {
  <div class="body-main">
    <!-- Header Bar Labels -->
    <div class="bar-header">
      <div class="bar-title">
        {{ "manager.Users.title" | translate }}
      </div>
      <div class="bar-description">
        {{ "manager.Users.subtitle" | translate }}
      </div>
    </div>
    <!-- Page Content Main -->
    <div class="page-content">
      @if (!isAddUser) {
        <app-manager-list
          (add)="addUser($event)"
          (selectElement)="selectUser($event)"
          (changeFilter)="changeFilterUser($event)"
          (changePage)="changePageUser($event)"
          [displayObjects]="users"
          [maxItems]="numberOfAllUsers"
          [properties]="userProperties"
        ></app-manager-list>
      }
    </div>
  </div>
}

@if (isAddUser) {
  <div class="body-main">
    <!-- Header Bar Buttons -->
    <div class="title-sample-header">
      <div class="page-title-left" (click)="backToList()">
        <div class="path">{{ "manager.Users.title" | translate }}</div>
        <div class="separator">/</div>
      </div>
      <div class="page-title-right">
        <div class="delete-image" (click)="deleteUser()">
          <svg-icon
            name="bin"
            [svgStyle]="{ fill: '#E40101', 'height.px': 16, 'width.px': 16 }"
          ></svg-icon>
        </div>
        <div class="action-buttons">
          <div class="cancel-button" (click)="backToList()">
            <div class="text">{{ "misc.cancel" | translate }}</div>
          </div>
          <div
            [class]="
              newUserIsValid === true ? 'save-button' : 'save-button-disabled'
            "
            (click)="saveChanges()"
          >
            <div class="text">
              {{ "manager.form.validFormLabel." + updateModeLabel | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Page Content Detail -->
    <div class="page-content">
      <!-- Side Nav -->
      <div class="nav-section-list">
        @for (nav of navObject; track nav.navName; let i = $index) {
          <div class="navigator" (click)="onNavChange(nav)">
            <div [ngClass]="nav.selectorStyle">
              {{ "manager.navName." + nav.navName | translate }}
            </div>
          </div>
        }
      </div>
      <!-- Nav Content -->
      <div class="main-section">
        <!-- Tab 1 -->
        <div [class]="selectedNav !== 'User' ? 'hidden' : 'form-holder'">
          <div class="title-main-section">
            <div class="text-box">
              {{ "manager.navName." + formConfig.title | translate }}
            </div>
            <div class="bottom-border"></div>
          </div>
          <app-manager-form
            (newObject)="changeSelectedUser($event)"
            (formIsValid)="isFormValid($event)"
            [formConfig]="formConfig"
            [update]="updateMode"
          ></app-manager-form>
        </div>
        <!-- Tab 2 -->
        <div
          [class]="selectedNav !== 'authorizedCt' ? 'hidden' : 'list-holder'"
        >
          <app-manager-list
            (selectElement)="selectAuthorizedCT($event)"
            (changeFilter)="changeFilterAuthorizedCT($event)"
            (changePage)="changePageAuthorizedCT($event)"
            [displayObjects]="authorizedCTs"
            [maxItems]="numberOfAllAuthorizedCTs"
            [properties]="authCtProperties"
          ></app-manager-list>
        </div>
      </div>
    </div>
  </div>
}
